/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cover_LettersInputs */

const en_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const de_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

const fr_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettres de motivation`)
};

const es_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartas de presentación`)
};

const it_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettere di presentazione`)
};

const nl_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motieven`)
};

const pl_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listy motywacyjne`)
};

const fi_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kansilehdet`)
};

const da_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbreve`)
};

const sv_nav_cover_letters = /** @type {(inputs: Nav_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningsbrev`)
};

/**
* | output |
* | --- |
* | "Cover Letters" |
*
* @param {Nav_Cover_LettersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_cover_letters = /** @type {((inputs?: Nav_Cover_LettersInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cover_LettersInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_cover_letters(inputs)
	if (locale === "fr") return fr_nav_cover_letters(inputs)
	if (locale === "es") return es_nav_cover_letters(inputs)
	if (locale === "it") return it_nav_cover_letters(inputs)
	if (locale === "nl") return nl_nav_cover_letters(inputs)
	if (locale === "pl") return pl_nav_cover_letters(inputs)
	if (locale === "fi") return fi_nav_cover_letters(inputs)
	if (locale === "da") return da_nav_cover_letters(inputs)
	if (locale === "sv") return sv_nav_cover_letters(inputs)
	return en_nav_cover_letters(inputs)
});